// import { latLng, LatLng } from 'leaflet';
import React, { useState, useMemo } from 'react';

const LayerContext: any = React.createContext({});

function LayerContextProvider({ children }: any) {
	const [point, setPoint] = useState([0, 0]);
	const [points, setPoints] = useState([]);
	const [allPoints, setAllPoints] = useState([]);
	const [drawedPoints, setDrawedPoints] = useState([]);
	const [selectedPointIdGlobal, setSelectedPointIdGlobal] = useState('');
	const [pointInfo, setPointInfo] = useState([0, 0]);
	const [map, setMap] = useState(null);
	const [activePark, setActivePark] = React.useState<any>(null);

	
	// eslint-disable-next-line react/jsx-no-constructed-context-values
	const defaultValue = {
		point,
		setPoint,
		points,
		setPoints,
		allPoints,
		setAllPoints,
		drawedPoints,
		setDrawedPoints,
		selectedPointIdGlobal,
		setSelectedPointIdGlobal,
		pointInfo,
		setPointInfo,
		map,
		setMap,
		activePark,
		setActivePark,
	};
	

	return (
		<LayerContext.Provider value={defaultValue}>
			{children}
		</LayerContext.Provider>
	);
}

export { LayerContext, LayerContextProvider };
